function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M89 45c0 24.3-19.7 44-44 44S1 69.3 1 45 20.7 1 45 1s44 19.7 44 44z",
  fill: "#fff",
  stroke: "#3E3E3F",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M50.133 49.6h-11.2a.933.933 0 110-1.867h11.2a.932.932 0 110 1.867zM50.133 44.933h-11.2a.933.933 0 110-1.866h11.2a.933.933 0 110 1.866zM50.133 40.267h-11.2a.934.934 0 010-1.867h11.2a.933.933 0 110 1.867z",
  fill: "#3E3E3F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.95 54.267h-8.835A2.118 2.118 0 0138 52.15V35.849c0-1.166.948-2.116 2.115-2.116h8.836c1.166 0 2.116.95 2.116 2.116v16.302c0 1.166-.95 2.116-2.116 2.116zM40.116 35.6a.25.25 0 00-.248.25v16.3c0 .138.11.25.248.25h8.836a.25.25 0 00.249-.25v-16.3a.25.25 0 00-.25-.25h-8.835z",
  fill: "#3E3E3F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M46.401 35.6h-3.733a.934.934 0 01-.934-.933v-3.734c0-.515.419-.933.934-.933H46.4c.516 0 .933.418.933.933v3.734a.933.933 0 01-.933.933zm-2.8-1.867h1.867v-1.866H43.6v1.866z",
  fill: "#3E3E3F"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M32.967 17.598c-.538.3-1.196 1.018-1.495 1.556-.48.928-.51 2.573-.45 25.67.077 23.022.024 25.401 1.182 26.473.211.196.463.348.763.575.838.598 1.137.628 11.669.628 10.083 0 10.89-.03 11.758-.569.315-.188.578-.306.797-.48 1.174-.93 1.097-3.441 1.148-26.716.05-23.093.161-25.657-1.02-26.602-.241-.192-.536-.317-.895-.535-.898-.568-1.586-.598-11.728-.598-10.143 0-10.831.03-11.729.598zm4.997 1.317c0 1.466.838 1.675 6.792 1.675 5.086 0 5.505-.03 6.073-.598.33-.33.599-.868.599-1.197 0-.538.209-.598 1.914-.598 1.646 0 2.065.12 2.843.778.588.493.927 1.22.927 1.988v47.688c0 .662-.27 1.296-.748 1.755a2.433 2.433 0 01-1.755.748h-9.824c-9.507-.025-11.105-.03-11.788-.822-.138-.16-.238-.353-.359-.585-.269-.478-.359-7.12-.359-25.221V21.159c0-.785.312-1.539.868-2.095.808-.777 1.077-.867 2.842-.867 1.885 0 1.975.03 1.975.718z",
  fill: "#3E3E3F"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M32.967 17.598c-.538.3-1.196 1.018-1.495 1.556-.48.928-.51 2.573-.45 25.67.077 23.022.024 25.401 1.182 26.473.211.196.463.348.763.575.838.598 1.137.628 11.669.628 10.083 0 10.89-.03 11.758-.569.315-.188.578-.306.797-.48 1.174-.93 1.097-3.441 1.148-26.716.05-23.093.161-25.657-1.02-26.602-.241-.192-.536-.317-.895-.535-.898-.568-1.586-.598-11.728-.598-10.143 0-10.831.03-11.729.598zm4.997 1.317c0 1.466.838 1.675 6.792 1.675 5.086 0 5.505-.03 6.073-.598.33-.33.599-.868.599-1.197 0-.538.209-.598 1.914-.598 1.646 0 2.065.12 2.843.778.588.493.927 1.22.927 1.988v47.688c0 .662-.27 1.296-.748 1.755a2.433 2.433 0 01-1.755.748h-9.824c-9.507-.025-11.105-.03-11.788-.822-.138-.16-.238-.353-.359-.585-.269-.478-.359-7.12-.359-25.221V21.159c0-.785.312-1.539.868-2.095.808-.777 1.077-.867 2.842-.867 1.885 0 1.975.03 1.975.718z",
  stroke: "#000"
});

function SvgSmartphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default __webpack_public_path__ + "769954cecf1e4614e0098b41b309ce56.svg";
export { SvgSmartphone as ReactComponent };